import { Database, Q } from '@nozbe/watermelondb'
import { ComponentInfoChatVO } from '@repo/types'
import { Chat } from '../model'

const buildMatchClause = (payload: ComponentInfoChatVO[]) =>
  Q.or(
    ...payload.map(chat =>
      Q.and(Q.where('key', chat.key))
    )
  )

export const addChatsInBatch = async (payload: ComponentInfoChatVO[], database: Database): Promise<void> => {
  if (!payload.length) return

  try {
    await database.write(async writer => {
      const chatsCollection = database.get<Chat>('chats')
      const existing = await chatsCollection.query(buildMatchClause(payload)).fetch()
      const byKey = new Map(existing.map(chat => [`${chat.key}`, chat]))

      const chatsToUpdate = payload.map(chatVO => {
        const foundChat = byKey.get(chatVO.key)

        if (foundChat) {
          return foundChat.prepareUpdate(chat => chat.setChatByComponentInfoChatVO(chatVO))
        } else {
          return chatsCollection.prepareCreate(chat => chat.setChatByComponentInfoChatVO(chatVO))
        }
      })

      await writer.batch(...chatsToUpdate)
    })
  } catch (e) {
    console.error(e)
  }
}
